
import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function TermsOfServicePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigateToHome = () => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE('/');
    }
  };

  const scrollToSection = (sectionId: string) => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white">
      <Header 
        cartCount={0}
        onHomeClick={navigateToHome}
        onAboutClick={() => scrollToSection('about-section')}
        onContactClick={() => scrollToSection('contact')}
      />
      
      <div className="pt-32 pb-16">
        <div className="container mx-auto px-6 max-w-4xl">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Kullanım Şartları</h1>
            <p className="text-gray-400 text-lg">
              Web sitemizi kullanırken uymanız gereken şartlar ve koşullar
            </p>
          </div>

          <div className="bg-gray-900 rounded-lg p-8 space-y-8">
            <section>
              <h2 className="text-2xl font-bold mb-4 text-white">1. Genel Şartlar</h2>
              <div className="text-gray-300 space-y-4">
                <p>
                  Bu web sitesini kullanarak, aşağıdaki kullanım şartlarını kabul etmiş sayılırsınız. 
                  Bu şartları kabul etmiyorsanız, lütfen siteyi kullanmayınız.
                </p>
                <p>
                  Bu şartlar herhangi bir zamanda önceden haber verilmeksizin değiştirilebilir. 
                  Değişiklikler sitede yayınlandığı anda yürürlüğe girer.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 text-white">2. Fikri Mülkiyet Hakları</h2>
              <div className="text-gray-300 space-y-4">
                <p>
                  Bu sitede yer alan tüm sanat eserleri, fotoğraflar, metinler ve diğer içerikler 
                  telif hakkı ile korunmaktadır. Bu içeriklerin izinsiz kullanımı yasaktır.
                </p>
                <p>
                  Sanat eserlerinin telif hakları ilgili sanatçılara aittir. Eserlerin satışı 
                  durumunda telif hakları alıcıya devredilmez, sadece fiziksel eser sahipliği devredilir.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 text-white">3. Kullanıcı Sorumlulukları</h2>
              <div className="text-gray-300 space-y-4">
                <p>Kullanıcılar aşağıdaki davranışları sergilememeyi kabul eder:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Siteye zarar verebilecek herhangi bir yazılım veya kod yüklemek</li>
                  <li>Diğer kullanıcıların hesaplarına yetkisiz erişim sağlamaya çalışmak</li>
                  <li>Yanıltıcı veya yanlış bilgi vermek</li>
                  <li>Spam veya istenmeyen içerik göndermek</li>
                  <li>Telif hakkı ihlali yapacak içerik paylaşmak</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 text-white">4. Satış ve Ödeme Şartları</h2>
              <div className="text-gray-300 space-y-4">
                <p>
                  Sitede yer alan tüm fiyatlar Türk Lirası olarak belirtilmiştir ve KDV dahil değildir. 
                  Fiyatlar önceden haber verilmeksizin değiştirilebilir.
                </p>
                <p>
                  Ödeme işlemleri güvenli ödeme sistemleri üzerinden gerçekleştirilir. 
                  Kredi kartı bilgileriniz şifrelenerek korunur.
                </p>
                <p>
                  Satış sözleşmesi, ödemenin onaylanması ve eserin hazırlanması ile tamamlanır.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 text-white">5. Teslimat ve İade</h2>
              <div className="text-gray-300 space-y-4">
                <p>
                  Sanat eserleri özel ambalajlama ile güvenli bir şekilde kargo ile gönderilir. 
                  Teslimat süresi 5-10 iş günüdür.
                </p>
                <p>
                  Hasarlı teslimat durumunda, eseri teslim almayınız ve durumu derhal bize bildirin. 
                  Hasar fotoğrafları ile birlikte bildirim yapılması gerekmektedir.
                </p>
                <p>
                  Özel sipariş eserlerde iade kabul edilmez. Stok eserler için 14 gün içinde 
                  iade hakkı bulunmaktadır.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 text-white">6. Gizlilik ve Kişisel Veriler</h2>
              <div className="text-gray-300 space-y-4">
                <p>
                  Kişisel verileriniz KVKK kapsamında korunur ve sadece sipariş işlemleri için kullanılır. 
                  Detaylı bilgi için Gizlilik Politikamızı inceleyiniz.
                </p>
                <p>
                  Üçüncü taraflarla kişisel bilgileriniz paylaşılmaz. E-posta adresiniz sadece 
                  sipariş durumu ve önemli bilgilendirmeler için kullanılır.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 text-white">7. Sorumluluk Sınırlaması</h2>
              <div className="text-gray-300 space-y-4">
                <p>
                  Site yönetimi, teknik arızalar, kesintiler veya veri kayıplarından dolayı 
                  oluşabilecek zararlardan sorumlu değildir.
                </p>
                <p>
                  Sanat eserlerinin renk farklılıkları monitör ayarlarından kaynaklanabilir. 
                  Bu durum iade sebebi sayılmaz.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 text-white">8. Uygulanacak Hukuk</h2>
              <div className="text-gray-300 space-y-4">
                <p>
                  Bu kullanım şartları Türkiye Cumhuriyeti kanunlarına tabidir. 
                  Uyuşmazlıklar İstanbul mahkemelerinde çözülür.
                </p>
                <p>
                  Bu şartların herhangi bir maddesi geçersiz sayılsa bile, diğer maddeler 
                  geçerliliğini korur.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 text-white">9. İletişim</h2>
              <div className="text-gray-300 space-y-4">
                <p>
                  Kullanım şartları ile ilgili sorularınız için bizimle iletişime geçebilirsiniz:
                </p>
                <div className="bg-gray-800 p-4 rounded-lg">
                  <p><strong>E-posta:</strong> info@sanatgalerisi.com</p>
                  <p><strong>Telefon:</strong> +90 212 555 0123</p>
                  <p><strong>Adres:</strong> Beyoğlu, İstanbul</p>
                </div>
              </div>
            </section>

            <div className="border-t border-gray-700 pt-8 mt-8">
              <p className="text-gray-400 text-sm text-center">
                Son güncelleme: {new Date().toLocaleDateString('tr-TR')}
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
